export default "__VITE_ASSET__D1LX27Bz__"